import styled from "styled-components"

export const GradientText = styled.span`
  background: ${(props) => props.theme.highlightGradient};
  background-clip: text;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const Headline = styled.div`
  margin-bottom: 16px;
  ${(props) => props.theme.typography.sectionHeadline};
  color: ${(props) => props.theme.textColor};
  white-space: break-spaces;
  text-align: center;

  /* common style for mobile and tab */
  @media (max-width: 1023px) {
    white-space: normal;
    margin-bottom: 12px;
    font-size: 1.375rem;
  }

  /* Mobile: 600 */
  @media (max-width: 600px) {
    text-align: left;
  }
`
export const StyledGradientTitle = styled(GradientText)`
  ${(props) => props.theme.typography.sectionHeadline};
  @media (max-width: 1023px) {
    font-size: 1.375rem;
  }
`

export const StyledGradientTitleInverse = styled.span`
  ${(props) => props.theme.typography.sectionHeadline};
  background: ${(props) => props.theme.indicatorGradient};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 876px) {
    font-size: 1.875rem;
  }
  @media (max-width: 641px) {
    font-size: 1.5rem;
    font-weight: 600;
  }
`

export const Descripition = styled.div`
  ${(props) => props.theme.typography.paragraph1}
  margin-bottom: 40px;
  line-height: 170%;
  letter-spacing: 0%;
  text-align: center;
  white-space: pre-wrap;
  color: ${(props) => props.theme.descriptionColor};

  /* common style for mobile and tab */
  @media (max-width: 1023px) {
    font-size: 0.875rem;
    white-space: normal;
    margin-bottom: 20px;
  }

  /* Mobile: 600 */
  @media (max-width: 600px) {
    text-align: left;
  }
`
